import {createActions} from 'fluxury';

const Actions = createActions(
  'loadStates',
  'loadPrograms',
  'changeSelectedState'
);

module.exports = Actions;



// WEBPACK FOOTER //
// ./src/actions/actions.js